<template>
    <el-card class="card-box block-params pfixed" :body-style="{ padding: 0 }">
        <el-form label-position="top">
            <el-collapse v-model="activeFields">
                <!-- PARAMS : RATE CATEGORIES -->
                <div v-if="!!paramsConfig.rateCategories" class="mt-1 el-collapse-item">
                    <el-form-item class="m-0" prop="paramsSettings.rate_categories">
                        <span slot="label" class="gray-100 semibold">
                            {{ $l10n.__('Catégorie Tarifaire') }}
                        </span>
                        <el-select
                            v-model="rateCategories"
                            class="wp-10"
                            :data-bot="getDatabot('select', entity, 'rate-categories', sideParam)"
                        >
                            <el-option
                                v-for="option in rateCategoriesList"
                                :key="option.label"
                                :value="option"
                                :label="option.label"
                            />
                        </el-select>
                    </el-form-item>
                </div>

                <!-- PARAMS : NOTE -->
                <el-collapse-item
                    name="note"
                    v-if="paramsConfig.note"
                    :data-bot="getDatabot(null, entity, 'note', sideParam)"
                >
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Note') }}
                        </span>
                    </template>
                    <div class="mt-1">
                        <el-form-item prop="note" class="third-params-note mb-0">
                            <div class="richtext-note rich-text-style">
                                <RichText
                                    v-model="note"
                                    :placeholder="$t.__('common.actions.write_note')"
                                    :options="optionsRichText"
                                    :is-custom="true"
                                    :data-bot="getDatabot('editor', entity, 'note', sideParam)"
                                />
                            </div>
                        </el-form-item>
                    </div>
                </el-collapse-item>

                <!-- PARAMS : OPPORTUNITY NUMBER / ID CODE -->
                <el-collapse-item name="idCode" v-if="paramsConfig.idCode">
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Numéro opportunité') }}
                        </span>
                    </template>
                    <div class="mt-1">
                        <el-form-item prop="paramsSettings.idCode">
                            <el-input autocomplete="off" v-model="idCode"></el-input>
                        </el-form-item>
                    </div>
                </el-collapse-item>

                <!-- PARAMS : OWNER & STAFF -->
                <el-collapse-item name="staff" v-if="paramsConfig.staffs">
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Affectation') }}
                        </span>
                    </template>
                    <div class="mt-1">
                        <el-form-item class="m-0" prop="owner">
                            <span slot="label" class="gray-100 lh-20">
                                {{ $l10n.__('Propriétaire') }}
                            </span>
                            <select-input-with-avatar
                                class="wp-10"
                                mode="edit"
                                :options="staffList"
                                :value="owner"
                                :defaultValue="currentStaff.forename"
                                :displayAvatar="{ onOptions: true, onSelect: true }"
                                @input="updateOwner"
                            />
                        </el-form-item>

                        <el-form-item class="m-0 mt-2" prop="staff">
                            <span slot="label" class="gray-100 lh-20">
                                {{ $l10n.__('Collaborateur(s) affecté(s)') }}
                            </span>
                            <select-input-with-avatar
                                class="wp-10"
                                mode="edit"
                                :options="staffList"
                                :multiple="true"
                                :value="staff"
                                size="medium"
                                :displayAvatar="{ onOptions: true, onSelect: false }"
                                @input="updateStaff"
                            />
                        </el-form-item>
                    </div>
                </el-collapse-item>

                <!-- PARAMS : SOCIAL -->
                <el-collapse-item
                    name="social"
                    v-if="paramsConfig.social"
                    :data-bot="getDatabot(null, entity, 'social-networks', sideParam)"
                >
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Réseaux sociaux') }}
                        </span>
                    </template>
                    <div class="mt-1">
                        <el-form-item prop="paramsSettings.social.facebook">
                            <el-input
                                :placeholder="$t.__('common.labels.facebook')"
                                autocomplete="off"
                                v-model="facebook"
                                :data-bot="
                                    getDatabot('facebook', entity, 'social-networks', sideParam)
                                "
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="paramsSettings.social.twitter">
                            <el-input
                                :placeholder="$t.__('common.labels.twitter')"
                                autocomplete="off"
                                v-model="twitter"
                                :data-bot="
                                    getDatabot('twitter', entity, 'social-networks', sideParam)
                                "
                            ></el-input>
                        </el-form-item>
                        <el-form-item class="m-0" prop="paramsSettings.social.linkedin">
                            <el-input
                                :placeholder="$t.__('common.labels.linkedin')"
                                autocomplete="off"
                                v-model="linkedin"
                                :data-bot="
                                    getDatabot('linkedin', entity, 'social-networks', sideParam)
                                "
                            ></el-input>
                        </el-form-item>
                    </div>
                </el-collapse-item>

                <!-- PARAMS : SYNC PROVIDERS -->
                <el-collapse-item
                    name="syncProviders"
                    v-if="paramsConfig.syncProviders && syncProvidersList.length > 0"
                    :data-bot="getDatabot(null, entity, 'sync-settings', sideParam)"
                >
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Paramètres synchronisation') }}
                        </span>
                    </template>
                    <div class="mt-1">
                        <el-form-item
                            prop="sync-providers"
                            class="third-params-sync-providers mb-0"
                        >
                            <el-checkbox-group
                                class="flex-column"
                                v-model="syncProvidersDefault"
                                @change="updateSyncProviders"
                            >
                                <el-checkbox
                                    class="my-1"
                                    :data-bot="
                                        getDatabot(sync.value, entity, 'sync-settings', sideParam)
                                    "
                                    v-for="(sync, index) in syncProvidersList"
                                    :checked="sync.is_setup"
                                    :key="index"
                                    :label="sync"
                                    >{{ sync.label }}</el-checkbox
                                >
                            </el-checkbox-group>
                        </el-form-item>
                    </div>
                </el-collapse-item>

                <!-- PARAMS : MARKETING PARAMS -->
                <el-collapse-item name="marketing" v-if="paramsConfig.marketing">
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Paramètres Marketing') }}
                        </span>
                    </template>
                    <el-form-item prop="marketing" class="mb-0">
                        <el-checkbox-group
                            class="flex-column"
                            v-model="marketing"
                            @change="updateMarketing"
                        >
                            <el-checkbox
                                class="my-1"
                                v-for="(param, index) in marketingList"
                                :checked="marketing[param.code]"
                                :key="index"
                                :label="param"
                                >{{ param.label }}</el-checkbox
                            >
                        </el-checkbox-group>
                    </el-form-item>
                </el-collapse-item>

                <!-- PARAMS : SMART TAGS -->
                <el-collapse-item
                    name="smarttags"
                    v-if="paramsConfig.smarttags"
                    :data-bot="getDatabot(null, entity, 'smart-tags', sideParam)"
                >
                    <template slot="title">
                        <span class="semibold">
                            {{ $l10n.__('Smart tags') }}
                        </span>
                    </template>
                    <tags
                        :data-bot="getDatabot('editor', entity, 'smart-tags', sideParam)"
                        :linkedtype="smartTagslinkedType"
                        :edit="true"
                        :standalone="false"
                        :fetchTags="false"
                        :options="getSmartTags"
                        size="small"
                        @tagsUpdated="tagsUpdated"
                        class="tags-150 mt-3 smart-tags-input"
                    >
                        <!-- No title from Tags.vue -->
                        <span slot="title"></span>
                    </tags>
                </el-collapse-item>
            </el-collapse>
        </el-form>
    </el-card>
</template>

<script>
import SelectInputWithAvatar from 'vcomponents/inputs/SelectInputWithAvatar.vue';
import Tags from 'vcomponents/utilities/Tags.vue';
import DataBotsFormsMixins from 'mixins/DataBotsFormsMixins';

import RichText from 'vcomponents/richtext/RichText.vue';

export default {
    components: {
        SelectInputWithAvatar,
        Tags,
        RichText,
    },
    mixins: [DataBotsFormsMixins],
    props: {
        entity: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentStaff: null,
            sideParam: 'tablist',
            syncProvidersDefault: [],
            activeFields: ['note', 'idCode', 'staff'],
            marketing: [],
            optionsRichText: [
                'Heading',
                'Bold',
                'Italic',
                'Underline',
                'BulletList',
                'OrderedList',
                'TextAlign',
                'Divider',
                'Link',
            ],
        };
    },
    computed: {
        paramsConfig() {
            return this.$store.getters[`${this.entity}/getParamsConfig`];
        },
        social: {
            get() {
                return this.$store.getters[`${this.entity}/getSocial`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setSocial`, value);
            },
        },
        facebook: {
            get() {
                return this.$store.getters[`${this.entity}/getFacebook`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setFacebook`, value);
            },
        },
        twitter: {
            get() {
                return this.$store.getters[`${this.entity}/getTwitter`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setTwitter`, value);
            },
        },
        linkedin: {
            get() {
                return this.$store.getters[`${this.entity}/getLinkedin`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setLinkedin`, value);
            },
        },
        idCode: {
            get() {
                return this.$store.getters[`${this.entity}/getIdCode`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setIdCode`, value);
            },
        },
        note: {
            get() {
                return this.$store.getters[`${this.entity}/getNote`];
            },
            set(value) {
                this.$store.commit(`${this.entity}/setNote`, value);
            },
        },
        type() {
            return this.$store.getters[`${this.entity}/getType`];
        },
        rateCategoriesList() {
            return this.$store.getters[`${this.entity}/getRateCategoriesList`];
        },
        rateCategories: {
            get() {
                return this.isEntity(['company', 'individual'])
                    ? this.$store.getters[`${this.entity}/getRateCategories`]
                    : null;
            },
            set(value) {
                this.$store.commit(`${this.entity}/setRateCategories`, value);
            },
        },
        getSmartTags() {
            return this.$store.getters[`${this.entity}/smartTags`];
        },
        smartTagslinkedType() {
            return this.$store.getters[`${this.entity}/getSmartTagsType`];
        },
        syncProvidersList() {
            return this.$store.getters[`${this.entity}/getSyncProvidersList`];
        },
        marketingList() {
            return this.$store.getters[`${this.entity}/getMarketing`];
        },
        staff() {
            let staff = this.getStaff;
            if (this.paramsConfig?.staffs && !staff[0]) {
                this.currentStaff = this.$store.state.user;
                staff.push(this.currentStaff.id);
                return this.getStaff;
            }
            return staff;
        },
        owner() {
            let owner = this.getOwner;
            if (this.paramsConfig?.staffs && !owner) {
                this.currentStaff = this.$store.state.user;
                this.updateOwner(this.currentStaff.id);
                return this.getOwner;
            }
            return owner;
        },
        getOwner() {
            return this.$store.getters[`${this.entity}/getOwner`];
        },
        getStaff() {
            return this.$store.getters[`${this.entity}/getStaff`];
        },
        staffList() {
            return this.$store.getters[`${this.entity}/getStaffList`];
        },
    },
    created() {
        if (this.paramsConfig.marketing) {
            let marketing = [];
            for (let i = 0; i < this.marketingList.length; i++) {
                marketing[this.marketingList[i].code] = this.marketingList[i].value;
            }
            this.marketing = marketing;
        }
    },
    methods: {
        updateOwner(owner) {
            this.$store.commit(`${this.entity}/setOwner`, owner);
        },
        updateStaff(staff) {
            this.$store.commit(`${this.entity}/setStaff`, staff);
        },
        syncProviders(sync) {
            let currentSync = Object.entries(
                this.$store.getters[`${this.entity}/getSyncProviders`],
            ).find((params) => sync === params[0]);
            return !_.isUndefined(currentSync) && !_.isNil(currentSync) ? currentSync[1] : false;
        },
        // used on FormWrapper (save() method)
        resetNote() {
            this.note = '';
        },
        tagsUpdated(tags) {
            tags.forEach((tag) => {
                tag.linkedForm = true;
            });
            this.$store.dispatch(`${this.entity}/updateSmartTags`, tags);
        },
        updateSyncProviders(value) {
            this.$store.dispatch(`${this.entity}/updateSyncProviders`, value);
        },
        updateMarketing(value) {
            this.$store.dispatch(`${this.entity}/updateMarketing`, value);
        },
        isEntity(entity) {
            let search = this.entity.slice(0, this.entity.indexOf('Form'));
            return [entity.some((type) => type === search)];
        },
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';

.smart-tags-input .prelative .el-select--small .el-select__tags input {
    margin-left: 8px !important;
}

.el-form .block-params {
    left: auto !important;
    transform: unset !important;
    top: 10rem;
    right: 8rem !important;
    .editor-input {
        border: unset !important;
    }
    .third-params-note {
        .editor-input {
            .ProseMirror {
                border: none;
            }
            .p-2 {
                padding: 0 !important;
            }
            & > div:first-child {
                overflow-y: auto;
                max-height: 120px;
            }
        }
    }
    ::-webkit-scrollbar {
        width: 5px;
    }
    ::-webkit-scrollbar-thumb {
        background: $gray-05;
        border-radius: 10px;
    }

    .el-collapse,
    .el-collapse-item__wrap {
        margin-top: 0 !important;
        padding-bottom: 0 !important;
    }
}

.richtext-note {
    .ProseMirror {
        height: 180px;
    }
    .menu-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .menu {
        display: flex;
        gap: var(--spacing-0);

        &-action {
            display: flex;
            gap: var(--spacing-1);
        }
    }
}
</style>
